<template>
  <div class="node-palette">
    <div class="palette-header">
      <span class="palette-title">开始节点</span>
    </div>
    <div class="palette-group">
      <div v-for="(meta, key) in startNodes" :key="key"
        class="palette-item"
        draggable="true"
        @dragstart="onDragStart(key)"
        @dragend="onDragEnd"
        @click="$emit('addNode', key)"
      >
        <svg viewBox="0 0 24 24" class="pn-icon">
          <circle cx="12" cy="12" r="10" fill="none" stroke="#10b981" stroke-width="2"/>
          <polyline points="8,12 14,8 20,12 14,16" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="pn-label">{{ meta.name }}</span>
      </div>
    </div>

    <div class="palette-header">
      <span class="palette-title">任务节点</span>
    </div>
    <div class="palette-group">
      <div v-for="(meta, key) in taskNodes" :key="key"
        class="palette-item"
        draggable="true"
        @dragstart="onDragStart(key)"
        @dragend="onDragEnd"
        @click="$emit('addNode', key)"
      >
        <svg viewBox="0 0 24 24" class="pn-icon">
          <!-- 审批: 人形 -->
          <g v-if="key === 'approval'">
            <circle cx="12" cy="7" r="4" fill="none" stroke="#10b981" stroke-width="2"/>
            <path d="M4 22c0-4.4 3.6-8 8-8s8 3.6 8 8" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
          </g>
          <!-- 通知: 信封 -->
          <g v-else-if="key === 'notify'">
            <rect x="3" y="5" width="18" height="14" rx="2" fill="none" stroke="#10b981" stroke-width="2"/>
            <polyline points="3,7 12,14 21,7" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <!-- 子流程: 叠层方框+加号 -->
          <g v-else-if="key === 'subprocess'">
            <rect x="4" y="3" width="16" height="15" rx="3" fill="none" stroke="#10b981" stroke-width="2"/>
            <rect x="6" y="5" width="16" height="15" rx="3" fill="none" stroke="#10b981" stroke-width="1.5" stroke-dasharray="2,1"/>
            <line x1="12" y1="9" x2="12" y2="16" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
            <line x1="8.5" y1="12.5" x2="15.5" y2="12.5" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
          </g>
        </svg>
        <span class="pn-label">{{ meta.name }}</span>
      </div>
    </div>

    <div class="palette-header">
      <span class="palette-title">控制节点</span>
    </div>
    <div class="palette-group">
      <div v-for="(meta, key) in controlNodes" :key="key"
        class="palette-item"
        draggable="true"
        @dragstart="onDragStart(key)"
        @dragend="onDragEnd"
        @click="$emit('addNode', key)"
      >
        <svg viewBox="0 0 24 24" class="pn-icon">
          <!-- 条件: 菱形+问号 -->
          <g v-if="key === 'condition'">
            <rect x="4" y="4" width="16" height="16" rx="1" fill="none" stroke="#10b981" stroke-width="2" transform="rotate(45 12 12)"/>
            <path d="M11 10.5V10a2.5 2.5 0 015 0c0 1.5-2 2-2 3h2" fill="none" stroke="#10b981" stroke-width="1.8" stroke-linecap="round"/>
            <circle cx="12" cy="18" r="1.2" fill="#10b981"/>
          </g>
          <!-- 分流: 分支双箭头 -->
          <g v-else-if="key === 'split'">
            <line x1="2" y1="12" x2="9" y2="12" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
            <polyline points="6,8 10,12 6,16" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="10" y1="7" x2="19" y2="7" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
            <line x1="10" y1="17" x2="19" y2="17" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
            <polyline points="16,4 20,7 16,10" fill="none" stroke="#10b981" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="16,14 20,17 16,20" fill="none" stroke="#10b981" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <!-- 合流: 汇聚双箭头 -->
          <g v-else-if="key === 'join'">
            <line x1="2" y1="12" x2="9" y2="12" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
            <polyline points="6,8 10,12 6,16" fill="none" stroke="#10b981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <line x1="2" y1="7" x2="9" y2="7" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
            <line x1="2" y1="17" x2="9" y2="17" stroke="#10b981" stroke-width="2" stroke-linecap="round"/>
            <polyline points="6,4 2,7 6,10" fill="none" stroke="#10b981" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <polyline points="6,14 2,17 6,20" fill="none" stroke="#10b981" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>
        <span class="pn-label">{{ meta.name }}</span>
      </div>
    </div>

    <div class="palette-header">
      <span class="palette-title">结束节点</span>
    </div>
    <div class="palette-group">
      <div v-for="(meta, key) in endNodes" :key="key"
        class="palette-item"
        draggable="true"
        @dragstart="onDragStart(key)"
        @dragend="onDragEnd"
        @click="$emit('addNode', key)"
      >
        <svg viewBox="0 0 24 24" class="pn-icon">
          <circle cx="12" cy="12" r="10" fill="none" stroke="#10b981" stroke-width="2"/>
          <circle cx="12" cy="12" r="6" fill="#10b981"/>
        </svg>
        <span class="pn-label">{{ meta.name }}</span>
      </div>
    </div>

    <div class="palette-header">
      <span class="palette-title">插件节点</span>
    </div>
    <div class="palette-group">
      <div v-for="(meta, key) in pluginNodes" :key="key"
        class="palette-item"
        draggable="true"
        @dragstart="onDragStart(key)"
        @dragend="onDragEnd"
        @click="$emit('addNode', key)"
      >
        <svg viewBox="0 0 24 24" class="pn-icon">
          <!-- SQL插件: 数据库柱体 -->
          <g v-if="key === 'sqlplugin'">
            <ellipse cx="12" cy="5" rx="9" ry="3" fill="none" stroke="#10b981" stroke-width="2"/>
            <path d="M3 5v12c0 1.7 4 3 9 3s9-1.3 9-3V5" fill="none" stroke="#10b981" stroke-width="2"/>
            <path d="M3 11c0 1.7 4 3 9 3s9-1.3 9-3" fill="none" stroke="#10b981" stroke-width="1.5"/>
            <path d="M3 17c0 1.7 4 3 9 3s9-1.3 9-3" fill="none" stroke="#10b981" stroke-width="1.5"/>
          </g>
          <!-- WebApi插件: 地球 -->
          <g v-else-if="key === 'webplugin'">
            <circle cx="12" cy="12" r="10" fill="none" stroke="#10b981" stroke-width="2"/>
            <ellipse cx="12" cy="12" rx="4.5" ry="10" fill="none" stroke="#10b981" stroke-width="1.2"/>
            <line x1="2" y1="12" x2="22" y2="12" stroke="#10b981" stroke-width="1.2"/>
            <circle cx="12" cy="12" r="2" fill="#10b981"/>
          </g>
        </svg>
        <span class="pn-label">{{ meta.name }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { nodeTypes } from './flowState.js'
const emit = defineEmits(['addNode'])

const startNodes = computed(() => ({ start: nodeTypes.start }))
const taskNodes = computed(() => ({
  approval: nodeTypes.approval,
  notify: nodeTypes.notify,
  subprocess: nodeTypes.subprocess
}))
const controlNodes = computed(() => ({
  condition: nodeTypes.condition,
  split: nodeTypes.split,
  join: nodeTypes.join
}))
const endNodes = computed(() => ({ end: nodeTypes.end }))
const pluginNodes = computed(() => ({
  sqlplugin: nodeTypes.sqlplugin,
  webplugin: nodeTypes.webplugin
}))

function onDragStart(key) { window.draggingFlowNodeType = key }
function onDragEnd() { window.draggingFlowNodeType = null }
</script>

<style scoped>
.node-palette { width: 150px; background: #fff; border-right: 1px solid #e5e7eb; display: flex; flex-direction: column; flex-shrink: 0; overflow-y: auto; }
.palette-header { padding: 6px 10px; background: #f5f6f8; border-bottom: 1px solid #e5e7eb; }
.palette-title { font-size: 11px; font-weight: 600; color: #6b7280; }
.palette-group { padding: 4px; display: flex; flex-direction: column; gap: 2px; }
.palette-item { display: flex; align-items: center; gap: 8px; padding: 5px 8px; cursor: grab; user-select: none; border-radius: 4px; transition: background 0.15s; }
.palette-item:hover { background: #f3f4f6; }
.palette-item:active { cursor: grabbing; background: #e5e7eb; }
.pn-icon { width: 24px; height: 24px; flex-shrink: 0; }
.pn-label { font-size: 11px; color: #374151; white-space: nowrap; }
</style>
